import React from "react";
import PageLayout from "../Layout";
import { SkeletonLoading } from "./SkeletonLoading";


export function PageLoading() {
    return <PageLayout sidebar={true} showHeader={true} title={""} isLoading={true}>
        <SkeletonLoading />
    </PageLayout>;
}